module.exports = __webpack_public_path__ + "static/media/appointment.764cbe1a.png";